/* ==========================================================================
   SearcherFli > Client > Destination
   ========================================================================== */

/* Modules */
const Autocomplete = require('@bluekiri/alexandria-contrib-components/components/autocomplete-rxjs/client/js');

/* eslint-disable */
const AutocompleteActions = require('@bluekiri/alexandria-contrib-components/components/autocomplete-rxjs/client/js/store/actions');
/* eslint-enable */

const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');

const { renderDestination } = require('../../../renders');

const { actions } = require('../store/actions');

const configuration = require('../config');

function addErrorMessage(instance) {
    const { config, destination } = instance;
    const { literals } = config;
    const { errorSameOriginDestination = 'errorSameOriginDestination' } = literals;

    const node = toNode(`<div class='searcher__error'>${errorSameOriginDestination}</div>`)[0];

    destination.element.appendChild(node);

    setTimeout(() => (destination.element ? destination.element.removeChild(node) : false), 3000);
}

/* Is not like equal origin */
function isNotEqualToOrigin(instance) {
    const { origin, destination } = instance.store.select('data');

    if (!origin) {
        return true;
    }

    const { value: originValue } = origin;
    const { value: destinationValue } = destination;

    if (originValue === destinationValue) {
        instance.destination.actions.setError();
        addErrorMessage(instance);
        return false;
    }

    return true;
}

/* Is Empty */
function isEmptyDestination(instance) {
    const { value } = instance.destination.store.select('autocomplete');

    instance.destination.actions.setValid();

    if (!value) {
        instance.destination.actions.setError();
    }

    return !value;
}

/* Add */
function addDestination(instance) {
    if (instance.destination) return;

    /* Data */
    const { literals, context, destination } = instance.config;
    const value = instance.store.select('data').destination;

    /* Template */
    const template = renderDestination({ ...destination, value }, literals, context);

    /* Node */
    const node = toNode(template)[0];

    /* Add node */
    instance.hooks.middle.insertBefore(node, instance.passengers.element);

    /* Init */
    initDestination(instance);
}

/* Init */
function initDestination(instance) {
    const panel = instance;

    /* Actions */
    panel.actions = {
        ...instance.actions,
        changeDestination: payload => {
            return instance.store.dispatch(actions.changeDestination(payload));
        }
    };

    /* Reference */
    panel.destination = Autocomplete(
        `${instance.selector} [data-component='AutocompleteRxjs'][data-type='${configuration().type.destination}']`
    );

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        changeDestination: instance.destination.store.subscribe((_, action) => {
            if (action.type !== AutocompleteActions.types.CHANGE_VALUE) return;
            instance.destination.actions.resetStatus();
            /* Dispatch */
            instance.actions.changeDestination(action.payload);
            if (!isNotEqualToOrigin(instance)) {
                instance.actions.changeDestination(null);
                return;
            }
            instance.destination.actions.resetStatus();
        }),
        clearDestination: instance.destination.store.subscribe((_, action) => {
            if (action.type !== AutocompleteActions.types.CLEAR) return;

            /* Dispatch */
            instance.actions.setSearcher({ destination: null });
            instance.destination.actions.setError();
        })
    };

    /* Start */
    const { value } = instance.destination.store.select('autocomplete');

    if (!value) {
        return;
    }

    /* Sync */
    instance.actions.setSearcher({ destination: value });
}

/* Destroy */
function destroyDestination(instance) {
    const panel = instance;

    /* Reference */
    instance.destination.actions.destroy();
    delete panel.destination;

    /* Actions */
    delete panel.actions.changeDestination;

    /* Reactions */
    instance.reactions.changeDestination.unsubscribe();
    delete panel.reactions.changeDestination;
}

/* Exports */
module.exports = {
    addDestination,
    initDestination,
    destroyDestination,
    isEmptyDestination,
    isNotEqualToOrigin
};
